import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DownloadGlyph = /*#__PURE__*/createElement("g", {
  id: "download",
  style: {
    transform: 'scale(3.6)',
    strokeWidth: 0.2
  }
}, /*#__PURE__*/createElement("path", {
  d: "M14.4571 11.3142L12.4 13.2571C12.3714 13.2856 12.3143 13.3142 12.2571 13.3428C12.2 13.3713 12.1714 13.3713 12.1143 13.3713C12.0571 13.3713 12 13.3713 11.9714 13.3428C11.9143 13.3142 11.8857 13.2856 11.8286 13.2571L9.77143 11.3142C9.6 11.1428 9.6 10.8856 9.74285 10.7142C9.91428 10.5428 10.1714 10.5428 10.3429 10.6856L11.6857 11.9428V4.62848C11.6857 4.39991 11.8857 4.19991 12.1143 4.19991C12.3429 4.19991 12.5429 4.39991 12.5429 4.62848V11.9428L13.8857 10.6856C13.9714 10.5999 14.0857 10.5713 14.1714 10.5713C14.2857 10.5713 14.4 10.6285 14.4857 10.7142C14.6286 10.8856 14.6286 11.1428 14.4571 11.3142Z"
}), /*#__PURE__*/createElement("path", {
  d: "M17.8286 19.5713H6.17144C5.51429 19.5713 4.97144 19.057 4.97144 18.3999V9.59989C4.97144 8.97132 5.51429 8.42847 6.17144 8.42847H9.28572C9.51429 8.42847 9.71429 8.62847 9.71429 8.85704C9.71429 9.08561 9.51429 9.28561 9.28572 9.28561H6.17144C5.97144 9.28561 5.82858 9.42847 5.82858 9.59989V18.3999C5.82858 18.5713 5.97144 18.7142 6.17144 18.7142H17.8C18 18.7142 18.1429 18.5713 18.1429 18.3999V9.59989C18.1429 9.42847 18 9.28561 17.8 9.28561H14.7143C14.4857 9.28561 14.2857 9.08561 14.2857 8.85704C14.2857 8.62847 14.4857 8.42847 14.7143 8.42847H17.8286C18.4857 8.42847 19.0286 8.94275 19.0286 9.59989V18.3999C19.0286 19.057 18.4857 19.5713 17.8286 19.5713Z"
}));
const Download = createSvg({
  name: 'download',
  path: DownloadGlyph
});

export default Download;
export { DownloadGlyph };
